import React from 'react'
import { AppDataTable, NoDataFound } from '@components'
import { useRunningScrapersTable } from '../@hooks'
import { Skeleton } from '@mui/material'
import { numSearchesColumn, numSearchesDoneColumn, siteColumn, actionsColumn } from './@columns'

export default function RunningScrapersTable() {

    const { tableData, isLoading } = useRunningScrapersTable()

    if (isLoading) return <Skeleton variant='rectangular' height={500} />
    if (!isLoading && !tableData.length) return <NoDataFound />

    return <AppDataTable
        title="Batch Scraper Searches"
        data={tableData}
        columns={[siteColumn(), numSearchesColumn(), numSearchesDoneColumn(), actionsColumn()]}
    />
}